import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute({ children, redirectTo = '/login', allowedRoles = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log('ProtectedRoute - User:', user, 'Loading:', loading, 'Path:', location.pathname);
  }, [user, loading, location.pathname]);

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p>Checking authentication...</p>
        </div>
      </div>
    );
  }

  // If not loading and no user, redirect to login
  if (!user) {
    console.log('No user found, redirecting to login');
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Check role-based access if roles are specified
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    console.log('User role not allowed:', user.role, 'Allowed:', allowedRoles);
    // Redirect to appropriate dashboard based on role
    const dashboardMap = {
      client: '/dashboard',
      admin: '/admin/dashboard',
      agent: '/agent/dashboard',
      agency: '/agency/dashboard',
      business: '/business/dashboard'
    };
    return <Navigate to={dashboardMap[user.role] || '/dashboard'} replace />;
  }

  // User is authenticated and authorized, render children
  return children;
}
